import { toast } from "react-toastify";

export const handleDownload = (filePath, folderName) => {
  // Create an anchor element
  const anchor = document.createElement("a");
  // Set the href attribute to the URL of the file to download
  anchor.href = filePath; // Change "/path/to/your/sample_file.ext" to the actual path of your file
  // Set the download attribute to specify the filename
  anchor.target = "_blank";
  anchor.download = folderName; // Change "sample_file.ext" to your desired filename
  // Simulate a click on the anchor element to trigger the download
  anchor.click();
};

export const allowedExtensionsForImage = ["jpg", "jpeg", "png", "webp"];

function validateFileExtensions(allowedExtensions, files) {
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      return false;
    }
  }
  return true;
}

export const validateImage = (event) => {
  const files = event.target.files;
  const isValid = validateFileExtensions(allowedExtensionsForImage, files);
  if (!isValid) {
    toast.error("File is not valid!");
    return false;
  }
  return true;
};

export const findEmptyIndexes = (socialArray) => {
  return socialArray
    ?.map((item, index) => (!item?.url ? index : null))
    .filter((index) => index !== null);
};

export const generatePassword = ({ length = 10 }) => {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const special = "!@#$%^&*()_+[]{}<>?,.";

  const all = upper + lower + numbers + special;

  // Ensure at least one character from each category
  const getRandom = (str) => str[Math.floor(Math.random() * str.length)];
  let password = [
    getRandom(upper),
    getRandom(lower),
    getRandom(numbers),
    getRandom(special),
  ];

  // Fill the rest of the password length
  for (let i = 4; i < length; i++) {
    password.push(getRandom(all));
  }

  // Shuffle password so fixed positions aren't predictable
  return password.sort(() => 0.5 - Math.random()).join("");
};

export const getDetailsObject = (bannerType, val) => {
  switch (bannerType) {
    case "home":
      return {
        testimonial: {
          title: val?.testimonialTitle,
          description: val?.testimonialDesc,
        },
        partner: {
          title: val?.partnerTitle,
          description: val?.partnerDesc,
        },
        existence: {
          title: val?.existenceTitle,
          count: val?.existenceCount,
        },
        scholarAward: {
          title: val?.scholarAwardTitle,
          count: val?.scholarAwardCount,
        },
        beneficiary: {
          title: val?.beneficiaryTitle,
          count: val?.beneficiaryCount,
        },
        fundDistribution: {
          title: val?.fundDistributionTitle,
          count: val?.fundDistributionCount,
        },
        videoSection: {
          title: val?.videoSectionTitle,
          link: val?.videoSectionDesc,
        },
      };

    case "apply":
      return {
        eligibility: {
          title: val?.eligibilityTitle,
          description: val?.eligibilityDesc,
          subtitle: val?.eligibilitySubTitle,
        },
        timeline: {
          title: val?.timelineTitle,
          description: val?.timelineDesc,
        },
        faq: {
          title: val?.faqTitle,
          description: val?.faqDesc,
        },
      };

    case "Memorydoodle":
      return {
        publication: {
          title: val?.publicationTitle,
          description: val?.publicationDesc,
        },
        inspire: {
          title: val?.inspireTitle,
          description: val?.inspireDesc,
          image: val?.inspireImage,
        },
        impact: {
          title: val?.impactTitle,
          description: val?.impactDesc,
          image: val?.impactImage,
        },
        firstSubSection: {
          title: val?.firstSubSectionTitle,
          count: val?.firstSubSectionCount,
          image: val?.subSectionimage,
        },
        secondSubSection: {
          title: val?.secondSubSectionTitle,
          count: val?.secondSubSectionCount,
        },
        thirdSubSection: {
          title: val?.thirdSubSectionTitle,
          count: val?.thirdSubSectionCount,
        },
      };

    case "updatesAndBlogs":
      return {
        blog: {
          title: val?.blogTitle,
          description: val?.blogDesc,
        },
      };

    default:
      return {};
  }
};
